import {styled} from "@mui/material";

export const UserDisabledInputsContainer = styled('div')(() => {
    return {
        display: 'flex',
        alignItems: 'center',
        gap: '1rem'
    }
});

export const UserPasswordContainer = styled('div')(() => {
    return {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start'
    }
});